import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'

const PromoImage = styled.div`
  position: relative;
  background-image: linear-gradient(
    135deg,
    ${props => props.theme.palette.primary.main} 0%,
    ${props => props.theme.palette.secondary.main} 100%
  );
  margin: ${props => props.theme.spacing(6)}px
    ${props => props.theme.spacing(3)}px;
  overflow: hidden;
`
const PromoContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  padding: ${props => props.theme.spacing(6)}px;
  z-index: 9;
`
const PromoHeader = styled.h2`
  margin: 0 0 ${props => props.theme.spacing(1)}px 0;
  font-weight: 900;
  font-size: 2.5rem;
  line-height: 2rem;
  text-transform: uppercase;
  font-family: 'Work Sans', sans-serif;
  text-align: center;
  color: ${props => props.theme.palette.common.white};
`
const PromoCopy = styled.p`
  margin: 0 0 ${props => props.theme.spacing(6)}px 0;
  font-size: 1.5rem;
  line-height: 1.25rem;
  text-transform: uppercase;
  color: ${props => props.theme.palette.common.white};
  text-align: center;
`
const PromoHeaderTwo = styled.h2`
  margin: 0 0 ${props => props.theme.spacing(1)}px 0;
  font-weight: 900;
  font-size: 1.75rem;
  line-height: 1.25rem;
  text-transform: uppercase;
  font-family: 'Work Sans', sans-serif;
  text-align: left;
  color: ${props => props.theme.palette.common.white};
`
const PromoCopyTwo = styled.p`
  margin: 0 0 ${props => props.theme.spacing(6)}px 0;
  font-size: 1.25rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: ${props => props.theme.palette.common.white};
  text-align: left;
`

const PromoList = props => (
  <StaticQuery
    query={graphql`
      query {
        promoImage1: file(
          relativePath: { eq: "promo/soccer-promo_banner.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        promoImage2: file(
          relativePath: { eq: "promo/basketball-promo_banner.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        promoImage3: file(
          relativePath: { eq: "promo/football-promo_banner.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        promoImage4: file(
          relativePath: { eq: "promo/sidebar_banner-small.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const { pageContext } = props
      const { competition, sport } = pageContext
      return (
        <>
          {competition === 'epl' ||
          competition === 'mls' ||
          competition === 'la-liga' ||
          competition === 'serie-a' ||
          sport === 'soccer' ? (
            <PromoImage component={Link} to="/">
              <PromoContent>
                <PromoHeader>Odds Boost</PromoHeader>
                <PromoCopy>Tap and boost your price.</PromoCopy>
              </PromoContent>
              <Img fluid={data.promoImage1.childImageSharp.fluid} alt="" />
            </PromoImage>
          ) : (
            <PromoImage component={Link} to="/">
              <PromoContent>
                <PromoHeader>Odds Boost</PromoHeader>
                <PromoCopy>Tap and boost your price.</PromoCopy>
              </PromoContent>
              <Img fluid={data.promoImage2.childImageSharp.fluid} alt="" />
            </PromoImage>
          )}
          <PromoImage component={Link} to="/">
            <PromoContent>
              <PromoHeaderTwo>Multi Sport Insurance</PromoHeaderTwo>
              <PromoCopyTwo>$25 max refund per eligible wager</PromoCopyTwo>
            </PromoContent>
            <Img fluid={data.promoImage4.childImageSharp.fluid} alt="" />
          </PromoImage>
        </>
      )
    }}
  />
)

PromoList.propTypes = {
  pageContext: PropTypes.any,
}

export default PromoList
